<template>
    <ul :class="style['quick-evaluate']">
      <li
        v-for="(option, index) in options"
        :key="index"
        :class="style['evaluation-widget']"
        :style="getStyle(index)"
        @click="sendEvaluate(option.value, index)"
      >
        {{ option.text}}
      </li>
    </ul>
</template>

<script>
import { Chat } from 'src/apis'
import { useAppStore } from 'Store/app'
import style from './scss/_quick_reply.scss'

export default {
  name: 'ChatEvaluationWidget',
  setup() {
    return {
      appStore: useAppStore()
    }
  },
  props: {
    chat: { type: Object, required: true }
  },
  data() {
    return {
      options:[
        {text: this.$t('base.yes'), value: 'like'}, 
        {text: this.$t('base.no'), value: 'dislike'}, 
        {text: this.$t('base.neverAskAgain'), value: false}
      ],
      clickedIndex: -1
    }
  },
  computed: {
    style: () => style
  },

  methods: {
    getStyle(index){
      if (this.clickedIndex === index) {
        return {
          backgroundColor: '#e6e6e6',
          cursor: 'not-allowed',
          border: 'solid 1px #999',
          color: '#999'
        };
      } else if (this.clickedIndex !== -1) {
        return {
          opacity: '0.5',
          pointerEvents: 'none'
        };
      }
      return {
      }
    },
    sendEvaluate(value, index){
      this.clickedIndex = index
      const message_rich = this.chat.message_rich
      if(value){
        Chat.SendEvaluations(value, message_rich.evaluables).catch(console.error)
      }else{
        Chat.SendUserPreference(value).catch(console.error)
      }
    }
  }
}
</script>
